import React, { Fragment, useEffect, useState } from "react";
import { GetProducts, getByMkt } from "../../../server/Product";
import { getFilters } from "../../../server/Filter";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, Outlet, useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { globalFileIcon } from "../../../../axiosInstance";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const sidebarAdmin = [
    { Title: "קופונים", Link: "/admin/coupons" },
    { Title: "מוצרים", Link: "/admin/products", Img: "related-products.svg" },
    { Title: "מחלקות", Link: "/admin/category-edit", Img: "list.svg" },
    { Title: "מסנני מוצרים", Link: "/admin/filters", Img: "filter.svg" },
    { Title: "הזמנות", Link: "/admin/history", Img: "cart.svg" },
    {
      Title: "הגדרות משלוח",
      Link: "/admin/delivery-edit",
      Img: "settings.svg",
    },
    {
      Title: "יצירת מחסן",
      Link: "/admin/station",
      Img: "location.svg",
    },
    {
      Title: "ניהול מבצעים",
      Link: "/admin/sales-management",
      Img: "notifications.svg",
    },
    { Title: "לקוחות", Link: "/admin/users", Img: "clients.svg" },
    {
      Title: "השוואת מחירים",
      Link: "/admin/price-compare",
      Img: "bar_chart.svg",
    },
  ];

  return (
    <div style={{ paddingTop: "80px" }}>
      <div className="tab-header">
        {sidebarAdmin.map((element, index) => (
          <NavLink to={element.Link} className="tab" key={index}>
            <span>{element.Title}</span>
          </NavLink>
        ))}
      </div>
      <div className="outlet">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;
